import {ReactNode, createContext} from 'react';
import {InlineDatumComponentType, InlineDataService} from './types';
import {ExportedValuesProvider} from './ExportedValuesProvider';
import {
  InlineDataEventBus,
  InlineDataEventBusProvider,
} from './InlineDataEventBusProvider';

export type InlineDataComponentRegistry = {
  [name: string]: InlineDatumComponentType;
};

export type InlineDataRenderer = {
  service: InlineDataService;
  components: InlineDataComponentRegistry;
};

const NoService: InlineDataService = {
  fetch: () => {
    throw new Error('No inline data service provided');
  },
  action: () => {
    throw new Error('No inline data service provided');
  },
};

const defaultValue = {
  service: NoService,
  components: {},
};

export const InlineDataContext =
  createContext<InlineDataRenderer>(defaultValue);

export const InlineDataProvider = ({
  value = defaultValue,
  bus,
  children,
}: {
  value?: InlineDataRenderer;
  bus?: InlineDataEventBus;
  children: ReactNode;
}) => {
  return (
    <InlineDataContext.Provider value={value}>
      <InlineDataEventBusProvider value={bus}>
        <ExportedValuesProvider>{children}</ExportedValuesProvider>
      </InlineDataEventBusProvider>
    </InlineDataContext.Provider>
  );
};
